export default {
  SET_HEADER: 'SET_HEADER',
  SET_HEADER_SUCCESS: 'SET_HEADER_SUCCESS'

}
